// extracted by mini-css-extract-plugin
module.exports = {"stars":"RatingStars_stars__PfVo8","stars_single":"RatingStars_stars_single__bnLue"};